function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as settingsActions } from '../../reducers/settings.reducer';
import { actions as notificationActions } from '../../reducers/notification.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import FeatureFlagsCard from './feature-flags/FeatureFlagsCard.react';
import FeatureFlagsAdd from './feature-flags/FeatureFlagsAdd.modal';
import Card from '../common/card/Card.react';
import CardBody from '../common/card/CardBody.react';
import CardHeader from '../common/card/CardHeader.react';
import Button from '../common/Button.react';
import Select from '../common/form/Select.react';
import Input from '../common/form/Input.react';
var EmailTest = function EmailTest() {
  var dispatch = useDispatch();
  var _useState = useState({
      from: 'cms@posillicoinc.com',
      to: 'bjorkqvist.daniel@gmail.com',
      apiID: 'email-test'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var from = form.from,
    to = form.to;
  var isValid = function isValid() {
    return from.length > 0 && to.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Test Email"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Select, {
    placeholder: "From Email",
    value: from,
    options: [{
      sValue: 'cms@posillicoinc.com',
      sLabel: 'cms@posillicoinc.com'
    }, {
      sValue: 'noreply@posillicoinc.com',
      sLabel: 'noreply@posillicoinc.com'
    }, {
      sValue: 'info@pparknj.com',
      sLabel: 'info@pparknj.com'
    }],
    onChange: function onChange(_ref) {
      var sValue = _ref.sValue;
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        from: sValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "To Email",
    value: to,
    onChange: function onChange(e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        to: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Test",
    apiID: "email-test",
    onClick: function onClick() {
      dispatch({
        type: settingsActions.testEmail,
        payload: form
      });
    },
    style: {
      width: '100%'
    },
    disabled: !isValid()
  })))), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  })));
};
export default EmailTest;

/*

							<Button
								label='Add New Feature Flag'
								onClick={() => {
									addModalAction({
										component:
											<FeatureFlagsAdd
												featureFlagConstants={featureFlagConstants}
											/>,
									});
								}}
								style={{ width: '100%' }}
							/>

*/